import React from 'react';
import { withRouter } from 'react-router-dom';
import { formatter, domManipulator, enumHelper } from '../../../utils';
import { connect } from 'react-redux';
import * as messageActions from '../../../redux/messages/actions';
import './sendMessage.scss';
import Spin from '../../../components/loading';
import Select from 'react-select';
import * as discountCodesActions from '../../../redux/discountCodes/actions';
import ENUMS from '../../../enums';
import AutoComplete from '../../../components/autoComplete';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class EditMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageBodyError: false,
      messageTitleError: false,
      messageBody: null,
      messageTitle: '',
      expireTime: '',
      expireDate: ' ',

      receiverType: '',
      specialUsers: [],
      selectedUsersInfo: [],
      isSearched: false,
      minOrderInReservationValue: '',
      minSuccessfulReservationValue: '',
      specialUserIds: [],
      receiverTypesInputInvalidMessage: '',
      receiverTypesInputValidateStatus: '',
      showSpecialUsersDropDownFlag: false,
      receiver: '',
      messageReceiverError: false,
      receiverUsersInputInvalidMessage: '',
      messageTimeError: false,
      messageDateError: false,
      receiverInputValidateStatus: '',

      minOrderInReservationValueInputValidateStatus: '',
      minOrderInReservationValueInputInvalidMessage: '',

      minSuccessfulReservationValueInputValidateStatus: '',
      minSuccessfulReservationValueInputInvalidMessage: '',

      permittedUsersInputValidateStatus: '',
      permittedUsersInputInvalidMessage: '',

      minOrderAmountInputValidateStatus: '',
      minOrderAmountInputInvalidMessage: '',

      specialUserIdsInputValidateStatus: '',
      specialUserIdsInputInvalidMessage: ''
    };
  }
  formRef = React.createRef();
  datePickerRef = React.createRef();

  setMinOrderInReservationValue = event => {
    let { value } = event.target;
    this.setState({ minOrderInReservationValue: value });
  };

  setMinSuccessfulReservationValue = event => {
    let { value } = event.target;
    this.setState({ minSuccessfulReservationValue: value });
  };

  setReceiverType = item => {
    this.setState({ receiverType: { ...item } });
  };

  setDiscountCode = item => {
    this.setState({ discountCode: { ...item } });
  };

  renderPermittedUsersInput = () => {
    let {
      searchText,
      isSearched,
      discountCode,
      receiverType,

      specialUser,
      minSuccessfulReservationValue,
      minOrderInReservationValue,

      specialUsers,

      minOrderInReservationValueInputValidateStatus,
      minOrderInReservationValueInputInvalidMessage,

      minSuccessfulReservationValueInputValidateStatus,
      minSuccessfulReservationValueInputInvalidMessage,

      specialUserIdsInputValidateStatus,
      specialUserIdsInputInvalidMessage,

      discountCodeInputInvalidMessage,
      discountCodeInputValidateStatus
    } = this.state;

    let { editMode, discountCodesList, searchedSpecialUsersList = [] } = this.props;

    let {
      HAS_MIN_ORDER_IN_RESERVATION,
      HAS_MIN_SUCCESSFUL_RESERVATION,
      SPECIAL_USERS,
      DISCOUNT_CODE_USERS
    } = ENUMS.MESSAGE_RECEIVERS.values;

    switch (typeof receiverType == 'object' ? receiverType.value : specialUser) {
      case HAS_MIN_SUCCESSFUL_RESERVATION: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="minSuccessfulReservationValue">
              {locales('tables.count')}
            </label>
            <div className="">
              <input
                id="minSuccessfulReservationValue"
                name="minSuccessfulReservationValue"
                type="text"
                className={`form-control ${minSuccessfulReservationValueInputValidateStatus}`}
                onChange={this.setMinSuccessfulReservationValue}
                autoComplete="off"
                value={minSuccessfulReservationValue}
              />
              <div className="invalid-feedback">{minSuccessfulReservationValueInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case DISCOUNT_CODE_USERS: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="discountCode">
              {locales('tables.discountCode')}
            </label>
            <div className="w-100">
              <Select
                placeholder={
                  discountCode && discountCode.length ? discountCode : locales('labels.selectDiscountCode')
                }
                isMulti={false}
                className={`rc-dropdown ${!!discountCodeInputValidateStatus ? 'is-invalid' : ''}`}
                name="discountCode"
                onChange={this.setDiscountCode}
                value={discountCode}
                options={discountCodesList.map(item => ({
                  label: item.title,
                  value: item.id
                }))}
              />
              <div className="invalid-feedback">{discountCodeInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case HAS_MIN_ORDER_IN_RESERVATION: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="minOrderInReservationValue">
              {locales('tables.mintotalReservePrice')}
            </label>
            <div className="">
              <input
                id="minOrderInReservationValue"
                name="minOrderInReservationValue"
                type="text"
                className={`form-control ${minOrderInReservationValueInputValidateStatus}`}
                onChange={this.setMinOrderInReservationValue}
                autoComplete="off"
                value={minOrderInReservationValue}
              />
              <div className="invalid-feedback">{minOrderInReservationValueInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case SPECIAL_USERS: {
        return (
          <>
            <label className="rsee-form-label text-left" htmlFor="specialUserIds">
              {locales('titles.users')}
            </label>
            <AutoComplete
              id="specialUserIds"
              errorText={specialUserIdsInputInvalidMessage}
              name="specialUserIds"
              searchInputClassName={`col-12`}
              inputErrorClassName={`${specialUserIdsInputValidateStatus}`}
              containerClassName="d-flex flex-wrap col"
              searchedList={searchedSpecialUsersList}
              defaultList={specialUsers}
              onSearchInputChanged={this.onSearchInputChanged}
              onSearchComplete={this.handleAutoCompleteDone}
            />
          </>
        );
      }
      default:
        break;
    }
  };

  onSearchInputChanged = searchKey => {
    this.props.fetchSearchedSpecialUsers(`filter=(textPart~contains~${searchKey})`);
  };

  handleAutoCompleteDone = selectedIds => {
    this.setState({ specialUserIds: selectedIds });
  };

  submitForm = isPublished => {
    let expireDate = this.datePickerRef.current.value,
      expireTime,
      messageTitle = '',
      messageBody = '';
    let {
      messageBodyError,
      messageTitleError,
      messageDateError,
      messageReceiverError,
      messageTimeError,
      discountCode,
      specialUserIds,
      receiverType,
      minOrderInReservationValue,
      minSuccessfulReservationValue
    } = this.state;

    let errors = {},
      firstErrorElementId = '',
      isMinSuccessfulReservationValueValid,
      isMinOrderInReservationValueValid,
      isDiscountCodeValid,
      isSpecialUserIdsValid;

    Array.from(this.formRef.current).forEach(ele => {
      if (ele.value && ele.value.length)
        switch (ele.name) {
          case 'expiredAtJalaali': {
            expireDate = formatter.toStandard(this.datePickerRef.current.value);
            break;
          }
          case 'expireTime': {
            expireTime = ele.value;
            break;
          }
          case 'messageBody': {
            messageBody = formatter.toStandard(ele.value);
            break;
          }
          case 'messageTitle': {
            messageTitle = formatter.toStandard(ele.value);
            break;
          }
        }
    });

    if (
      !!receiverType &&
      receiverType.value == ENUMS.MESSAGE_RECEIVERS.values.SPECIAL_USERS &&
      !specialUserIds.length
    ) {
      errors.specialUserIdsInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.specialUsers')
      });
      errors.specialUserIdsInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'specialUserIds';
      isSpecialUserIdsValid = false;
    } else {
      errors.specialUserIdsInputInvalidMessage = '';
      errors.specialUserIdsInputValidateStatus = '';
      isSpecialUserIdsValid = true;
    }

    if (
      !!receiverType &&
      receiverType.value == ENUMS.MESSAGE_RECEIVERS.values.HAS_MIN_SUCCESSFUL_RESERVATION &&
      !minSuccessfulReservationValue
    ) {
      errors.minSuccessfulReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.minSuccessfulReservationValue')
      });
      errors.minSuccessfulReservationValueInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'minSuccessfulReservationValue';
      isMinSuccessfulReservationValueValid = false;
    } else {
      errors.minSuccessfulReservationValueInputInvalidMessage = '';
      errors.minSuccessfulReservationValueInputValidateStatus = '';
      isMinSuccessfulReservationValueValid = true;
    }

    if (
      !!receiverType &&
      receiverType.value == ENUMS.MESSAGE_RECEIVERS.values.DISCOUNT_CODE_USERS &&
      !discountCode
    ) {
      errors.discountCodeInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.discountCode')
      });
      errors.discountCodeInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'discountCode';
      isDiscountCodeValid = false;
    } else {
      errors.discountCodeInputInvalidMessage = '';
      errors.discountCodeInputValidateStatus = '';
      isDiscountCodeValid = true;
    }

    if (
      !!receiverType &&
      receiverType.value == ENUMS.MESSAGE_RECEIVERS.values.HAS_MIN_ORDER_IN_RESERVATION &&
      !minOrderInReservationValue
    ) {
      errors.minOrderInReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.minOrderInReservation')
      });
      errors.minOrderInReservationValueInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'minOrderInReservationValue';
      isMinOrderInReservationValueValid = false;
    } else {
      errors.minOrderInReservationValueInputInvalidMessage = '';
      errors.minOrderInReservationValueInputValidateStatus = '';
      isMinOrderInReservationValueValid = true;
    }

    if (!receiverType) {
      this.setState({ messageReceiverError: true });
    } else {
      this.setState({ messageReceiverError: false });
    }
    if (
      !formatter.toStandard(this.datePickerRef.current.value) &&
      !this.props.messageObject.expiredAtJalaali
    ) {
      this.setState({ messageDateError: true });
    } else {
      this.setState({ messageDateError: false });
    }
    if (!expireTime) {
      this.setState({ messageTimeError: true });
    } else {
      this.setState({ messageTimeError: false });
    }
    if (!messageTitle.length) {
      this.setState({ messageTitleError: true });
    } else {
      this.setState({ messageTitleError: false });
    }
    if (!messageBody.length) {
      this.setState({ messageBodyError: true });
    } else {
      this.setState({ messageBodyError: false });
    }

    let isFormValid =
      isSpecialUserIdsValid &&
      isDiscountCodeValid &&
      isMinOrderInReservationValueValid &&
      isMinSuccessfulReservationValueValid;
    if (!isFormValid) {
      return this.setState(
        () => ({
          ...errors
        }),
        () => {
          domManipulator.scrollIntoView(firstErrorElementId);
        }
      );
    }
    const { expiredAtJalaali } = this.props.messageObject;
    expireDate =
      formatter.toStandard(this.datePickerRef.current.value) ||
      formatter.toStandard(expiredAtJalaali.split('-')[0].replace(' ', ''));
    if (
      !messageBodyError &&
      !messageTitleError &&
      !messageDateError &&
      !messageTimeError &&
      !messageReceiverError &&
      isFormValid
    ) {
      let expiration = JSON.parse(
        `${expireDate && expireDate.split('/').join('')}${expireTime && expireTime.split(':').join('')}`
      );
      this.props
        .sendMessage(
          messageTitle,
          messageBody,
          isPublished,
          `${formatter.toStandard(expiration)}`,
          specialUserIds,
          receiverType.value,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          typeof discountCode == 'object' ? discountCode.value : discountCode
        )
        .then(() => {
          this.props.history.push('/messages');
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessfully'),
            text: '',
            type: 'success'
          });
        });
    }
  };

  componentDidUpdate(prevProps) {
    if (!Object.entries(prevProps.messageObject).length && Object.entries(this.props.messageObject).length) {
      let {
        body,
        title,
        expiredAtJalaali,
        receiverType,
        specialUsers,
        minSuccessfulReservationValue,
        discountCodeId,
        minOrderInReservationValue,
        specialUserIds
      } = this.props.messageObject;
      let date = formatter.toStandard(expiredAtJalaali.split('-')[0].replace(' ', ''));
      let time = formatter.toStandard(expiredAtJalaali.split('-')[1].replace(' ', ''));
      this.datePickerRef.current.value = date;
      this.setState({
        minSuccessfulReservationValue,
        discountCodeId,
        minOrderInReservationValue,
        specialUserIds,
        specialUsers,
        receiverType: {
          value: receiverType,
          label: enumHelper.convertEnumValueToTitle(ENUMS.MESSAGE_RECEIVERS.list, receiverType)
        },
        expireTime: formatter.toStandard(time),
        expireDate: formatter.toStandard(date),
        messageBody: body,
        messageTitle: title
      });
    }
  }

  componentWillUnmount() {
    this.props.emptyMessageObject();
  }

  componentDidMount() {
    if (this.props.location.messageId)
      return this.props.fetchMessageById(this.props.location.messageId).then(_ => {
        const { expiredAtJalaali } = this.props.messageObject;
        this.datePickerRef.current.value = formatter.toStandard(
          expiredAtJalaali.split('-')[0].replace(' ', '')
        );
      });
    return this.props.history.push('/messages');
  }

  clearForm = event => {
    if (event) event.preventDefault();
    return Array.from(this.formRef.current).forEach(ele => {
      ele.value = '';
      if (ele.name === 'expiredAtJalaali') ele.value = ' ';
    });
  };

  handleInputChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const {
      discountCodesLoading,
      discountCodesMessage,
      discountCodesFailed,
      discountCodesError,
      sendMessageLoading,
      sendMessageFailed,
      sendMessageError,
      sendMessageMessage,
      message,
      loading,
      searchedSpecialUsersLoading,
      searchedSpecialUsersMessage,
      searchedSpecialUsersFailed,
      searchedSpecialUsersError,
      failed,
      error
    } = this.props;

    let {
      messageBodyError,
      messageTitleError,
      messageReceiverError,
      showReceiverTypesDropDownFlag,
      receiver,
      receiverTypesInputInvalidMessage,
      receiverTypesInputValidateStatus,
      receiverType,

      receiverUsersInputInvalidMessage,
      messageDateError,
      messageTimeError,
      receiverInputValidateStatus,

      expireTime,
      messageBody,
      messageTitle
    } = this.state;

    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">{locales('titles.createNewMessage')}</h3>
          <div>
            <button onClick={() => this.submitForm(false)} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <button onClick={() => this.submitForm(true)} className="btn btn-primary w-5 mx-1">
              <i className="fal fa-upload mx-1" />
              {locales('labels.saveAndPublish')}
            </button>
            <button onClick={() => this.props.history.push('/messages')} className="btn btn-default w-5 mx-1">
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>
        <Spin spinning={loading || discountCodesLoading || searchedSpecialUsersLoading || sendMessageLoading}>
          {(error || discountCodesError || searchedSpecialUsersError || sendMessageError) && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {(failed || discountCodesFailed || sendMessageFailed || searchedSpecialUsersFailed) && (
            <div className="alert alert-danger">
              {message || discountCodesMessage || searchedSpecialUsersMessage || sendMessageMessage}
            </div>
          )}

          <main className="panel panel-default">
            <div className="panel-heading">
              <i className="fas fa-list-alt px-1" />
              {locales('titles.sendNewMessage')}
            </div>
            <div className="panel-body">
              <form ref={this.formRef} className="col-12 p-0">
                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('titles.messageTitle')}
                    </label>
                    <div className="full-width">
                      <input
                        name="messageTitle"
                        value={messageTitle}
                        onChange={this.handleInputChange}
                        className={`${messageTitleError ? 'border border-danger' : ''} col-12 form-control`}
                        placeholder={locales('titles.messageTitle')}
                      />
                      {messageTitleError && (
                        <label className="text-danger">{locales('errors.messageTitleRequired')}</label>
                      )}
                    </div>
                  </div>
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.body')}
                    </label>
                    <div className="full-width">
                      <textarea
                        name="messageBody"
                        value={messageBody}
                        onChange={this.handleInputChange}
                        className={`col-12 form-control ${messageBodyError ? 'border border-danger' : ''}`}
                        placeholder={locales('tables.body')}
                      />
                      {messageBodyError && (
                        <label className="text-danger">{locales('errors.messageBodyRequired')}</label>
                      )}
                    </div>
                  </div>
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.expiredAtJalaali')}
                    </label>
                    <div className="full-width">
                      <DatePicker
                        marge={true}
                        placeholder="تاریخ"
                        ref={this.datePickerRef}
                        name="expiredAtJalaali"
                        className={`${
                          messageDateError ? 'border border-danger' : ''
                        } col p-0 date-picker-input start border rounded py-2`}
                      />
                      {messageDateError && (
                        <label className="text-danger">{locales('errors.messageDateRequired')}</label>
                      )}
                    </div>
                  </div>
                </div>
                {/*
              <div className="form-group col d-flex required align-items-center">
                <label className="rsee-form-label" htmlFor="title">
                  {locales("labels.receiver")}
                </label>
                <div className='full-width'>
                  <Select
                    placeholder={locales('labels.chooseUsers')}
                    isMulti={false}
                    className={`rc-dropdown ${!!receiverInputValidateStatus ? 'is-invalid' : ''}`}
                    name="receiverTypesToUseCode"
                    onChange={this.setReceiver}
                    value={receiver}
                    options={ENUMS.MESSAGE_RECEIVERS.list.map(item => ({
                      label: item.title,
                      value: item.value
                    }))}
                  />
                  <div className="invalid-feedback">
                    {receiverUsersInputInvalidMessage}
                  </div>

                </div>
              </div> */}

                <div className="full-width my-3">
                  {
                    <div className="form-group col d-flex required align-items-center">
                      <label className="rsee-form-label text-right half-width" htmlFor="title">
                        {locales('labels.selectReceivers')}
                      </label>
                      <div className="full-width">
                        <Select
                          placeholder={
                            receiverType && receiverType.length
                              ? enumHelper.convertEnumValueToTitle(ENUMS.MESSAGE_RECEIVERS.list, receiverType)
                              : locales('labels.chooseUsers')
                          }
                          isMulti={false}
                          className={`rc-dropdown  ${!!messageReceiverError ? 'is-invalid' : ''}`}
                          name="receiverTypesToUseCode"
                          onChange={this.setReceiverType}
                          value={receiverType}
                          options={[...ENUMS.MESSAGE_RECEIVERS.list].map(item => ({
                            label: item.title,
                            value: item.value
                          }))}
                        />
                        {messageReceiverError && (
                          <label className="text-danger">{locales('errors.messageReceiverError')}</label>
                        )}
                        <div className="invalid-feedback">{receiverTypesInputInvalidMessage}</div>
                      </div>

                      <div className="form-group col-6 d-flex required align-items-center justify-content-start">
                        {!!receiverType && this.renderPermittedUsersInput()}
                      </div>
                    </div>
                  }
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.time')}
                    </label>
                    <div className="full-width">
                      <input
                        name="expireTime"
                        value={expireTime}
                        onChange={this.handleInputChange}
                        className={`form-control d-flex align-items-center justify-content-center ${
                          messageTimeError ? 'border border-danger' : ''
                        }`}
                        id="time"
                        type="time"
                      />
                      {messageTimeError && (
                        <label className="text-danger">{locales('errors.messageTimeRequired')}</label>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className='col-12 d-flex'>
                <label className='mx-2 d-flex justify-content-start p align-items-center' htmlFor="time">
                  {locales('tables.time')}:
                </label>
                <input
                  name='expireTime'
                  className='col-2 form-control d-flex align-items-center justify-content-center'
                  id="time"
                  type='time'
                />
              </div> */}
                <div className="col-12 d-flex justify-content-end my-2">
                  <button className="btn btn-info" onClick={event => this.clearForm(event)}>
                    {locales('labels.clearForm')}
                  </button>
                </div>
              </form>
            </div>
          </main>
        </Spin>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.messagesReducer.fetchMessageByIdLoading,
    message: state.messagesReducer.fetchMessageByIdMessage,
    failed: state.messagesReducer.fetchMessageByIdFailed,
    error: state.messagesReducer.fetchMessageByIdErrorS,
    messageObject: state.messagesReducer.messageObject,

    searchedSpecialUsersLoading: state.discountCodesReducer.searchedSpecialUsersLoading,
    searchedSpecialUsersFailed: state.discountCodesReducer.searchedSpecialUsersFailed,
    searchedSpecialUsersError: state.discountCodesReducer.searchedSpecialUsersError,
    searchedSpecialUsersMessage: state.discountCodesReducer.searchedSpecialUsersMessage,
    searchedSpecialUsers: state.discountCodesReducer.searchedSpecialUsers,
    searchedSpecialUsersList: state.discountCodesReducer.searchedSpecialUsersList,

    discountCodesLoading: state.messagesReducer.discountCodesLoading,
    discountCodesFailed: state.messagesReducer.discountCodesFailed,
    discountCodesError: state.messagesReducer.discountCodesError,
    discountCodesMessage: state.messagesReducer.discountCodesMessage,
    discountCodes: state.messagesReducer.discountsCode,
    discountCodesList: state.messagesReducer.discountCodesList,

    sendMessageLoading: state.messagesReducer.sendMessageLoading,
    sendMessageFailed: state.messagesReducer.sendMessageFailed,
    sendMessageError: state.messagesReducer.sendMessageError,
    sendMessageMessage: state.messagesReducer.sendMessageMessage
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllDiscountCodes: _ => dispatch(messageActions.fetchAllDiscountCodes()),
    fetchSearchedSpecialUsers: search => dispatch(discountCodesActions.fetchSearchedSpecialUsers(search)),
    emptyMessageObject: () => dispatch(messageActions.emptyMessageObject()),
    fetchMessageById: id => dispatch(messageActions.fetchMessageById(id)),
    sendMessage: (
      messageTitle,
      messageBody,
      isPublished,
      expiration,
      specialUserIds,
      receiverType,
      minOrderInReservationValue,
      minSuccessfulReservationValue,
      discountCode
    ) =>
      dispatch(
        messageActions.sendMessage(
          messageTitle,
          messageBody,
          isPublished,
          expiration,
          specialUserIds,
          receiverType,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          discountCode
        )
      )
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditMessage)
);
